function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFAF20"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M34 22.1c0 1.049-.846 1.9-1.891 1.9H6.89A1.896 1.896 0 0 1 5 22.1V6.9C5 5.851 5.846 5 6.891 5H32.11C33.154 5 34 5.851 34 6.9v15.2zM17 8.5h14.318M17 11.5h14.318M17 15.5h14.318M24.667 19.5h6.666M7.625 19.5H22"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11 12c1.657 0 3 1.79 3 4H8c0-2.21 1.343-4 3-4zm0-4c.994 0 1.8.896 1.8 2s-.806 2-1.8 2-1.8-.896-1.8-2 .806-2 1.8-2z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M38.5 29v-8M30 29h8M.5 29v-8M9 29H1M38.5.5v8M30 .5h8M.5.5v8M9 .5H1"
}));

var SvgRnePhotoIcon = function SvgRnePhotoIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 30,
    viewBox: "0 0 39 30",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRnePhotoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rne_photo_icon.b646401e.svg";
export { ForwardRef as ReactComponent };